module.exports = __webpack_public_path__ + "img/FAQ-zh.f89cc268.png";